import { createContext, useContext } from 'react'

export const EditorContext = createContext<{
  validationError: boolean
  parserError: boolean
}>({ validationError: false, parserError: false })

export const useEditorContext = () => useContext(EditorContext)
